/**
 * @enum {string}
 */
const ScheduleStatus = {
	BEHIND_RED: 'behind-red',
	BEHIND_YELLOW: 'behind-yellow',
	AHEAD: 'ahead',
	ON: 'on',
	NO_DATA: 'no-data'
}

export const BEHIND_RED = ScheduleStatus.BEHIND_RED
export const BEHIND_YELLOW = ScheduleStatus.BEHIND_YELLOW
export const AHEAD = ScheduleStatus.AHEAD
export const ON = ScheduleStatus.ON
export const NO_DATA = ScheduleStatus.NO_DATA
